module.exports = __webpack_public_path__ + "img/calendar.7157f20a.svg";